import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-header-espace-client',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header-espace-client.component.html',
  styleUrl: './header-espace-client.component.scss'
})
export class HeaderEspaceClientComponent {
  @Input() email: string = '';

  constructor(
    private router: Router,
    private loginService: LoginService
  ) {}

  /**
   * Gère la déconnexion de l'utilisateur
   */
  onLogout(): void {
    // Appeler la méthode de déconnexion du service
    this.loginService.logout();
    
    // Rediriger vers la page d'accueil
    this.router.navigate(['/']);
  }
}
